/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/no-webpack-loader-syntax */
/** 个人主页头部封面 */
import React, { useMemo, useCallback, useState, useContext } from 'react';
import type { FC } from 'react';
import { message } from '@tencent/tea-component';
import confirm from 'src/components/saleModal/method';
import QRCodeShare from './QRcodeShare';
import { AppContext } from '../../utils/browser/app-context';
import { useShareUrl } from './use-share';
import { HostDetailRes, HostDetailData } from '@model/host-account';
import { subscribe } from '@model/follow';
import DefaultBannerM from '@assets/imgs/default-banner-m.png';
import { useRouter } from 'next/router';
import { checkLogin, goLogin, navigateToLaunchIfNeed } from '@utils/login-util';
import { isMobile } from '@utils/ua/is-mobile';
import useOnce from 'src/hooks/useOnce';
import beaconReport from '@utils/beacon';
import FollowGuide from './FollowGuide';
import { isWeMeetApp, isWechat } from '@tencent/web-base';
import HomeHero from '@tencent/tpm-meeting-active/lib/HomeHero';
import '@tencent/tpm-meeting-active/lib/HomeHero/style';
import Button from '@tencent/tpm-meeting-active/lib/Button';
import '@tencent/tpm-meeting-active/lib/Button/style';
import ShareIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/ShareIcon';
import PencileIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/PencileIcon';
import CloseIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/CloseIcon';
import ViewIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/ViewIcon';
import { DrawerFormField } from 'src/pages/create/mobile/DrawerField';
import MemberOption from '@tencent/tpm-meeting-active/lib/MemberOption';
import '@tencent/tpm-meeting-active/lib/MemberOption/style';
import '@tencent/tpm-meeting-active/lib/TicketList/style';
import useCommercialize from '@hooks/useCommercialize';
import defaultBannerBase from '@assets/imgs/default-banner-base.png';
import defaultBannerLuxury from '@assets/imgs/default-banner-luxury.png';
import defaultBannerUltimate from '@assets/imgs/default-banner-ultimate.png';
import dayjs from 'dayjs';
import { formatUrl } from '@utils/imageLoad';
import useImageWidthHooks from '@hooks/useImageWidthHooks';
import style from './index.module.scss';
import useShowShare from '@component/shareShield';

const openSpace = (hostId?: string | number) => {
  const toUrl = `${process.env.basePath}/space?host_id=${hostId}&preview=1`;
  if (!hostId) {
    console.error('hostId not exist');
    return;
  }
  if (isMobile()) {
    window.location.href = toUrl;
  } else {
    window.open(toUrl, '_blank');
  }
};
const Btns: FC<{
  isVisit?: boolean;
  isOwner?: boolean;
  hostData?: HostDetailRes['data'];
  hostId?: number | string;
  updateHostData?: Function;
}> = ({ isVisit, isOwner, hostData, hostId, updateHostData }) => {
  const hostDetail = hostData?.host_detail;
  // const { isMobileUi } = useContext(AppContext);
  const [show, setShow] = useState(false);
  const router = useRouter();
  // 主页分享进入 space/share 路由
  const qrCodeUrl = useShareUrl(hostId, router.pathname === '/home');
  const { showShare } = useShowShare();

  const { auto_follow: autoFollow = 'false' } = router.query as {
    host_id: string;
    auto_follow?: string;
  };
  const isSubscribe = useMemo(() => hostData?.is_subscribed, [hostData?.is_subscribed]);
  // @ts-ignore
  const toggleFollow = useToggleFollowHost(
    !!isSubscribe,
    hostId || '',
    !!isOwner,
    hostDetail,
    () => {
      console.log(hostDetail, (hostDetail?.fans_info?.fans_count || 0) + (isSubscribe ? -1 : 1));
      const arr = [
        {
          path: 'host_detail.fans_info.fans_count',
          value: (hostDetail?.fans_info?.fans_count || 0) + (isSubscribe ? -1 : 1),
        },
        {
          path: 'is_subscribed',
          value: !isSubscribe,
        },
      ];
      updateHostData?.(arr);
    },
  );

  /** 从 app 唤起到home或者space页面时,如果参数带了自动关注参数,则自动触发一下关注动作 */
  useOnce(() => {
    if (isOwner === undefined) return false;
    if (autoFollow === 'true') {
      toggleFollow(true, () => {
        message.success({ content: '关注成功' });
        // 移除 query 参数
        history.replaceState({}, '', location.href.replace(/&?auto_follow=true/, ''));
      });
      return true;
    }
    return false;
  }, [autoFollow, isOwner]);
  return (
    <>
      {isVisit && !isOwner && (
        <FollowGuide toggleSubscribe={toggleFollow} hostId={hostId} isSubscribed={isSubscribe} />
      )}
      {(isWeMeetApp() || !isMobile()) && showShare && (
        <Button
          type={isVisit && isOwner ? 'primary' : 'weak'}
          className={`ma-home-hero__btn ${isVisit && isOwner ? 'attention-btn special-width' : ''}`}
          onClick={() => {
            beaconReport('eventplace_hostview_ management_null_share_null_click');
            if (isMobile()) {
              router.push(`/space/share?host_id=${hostId}`);
              return;
            }
            setShow(true);
          }}
        >
          <ShareIcon />
          分享
        </Button>
      )}
      {!isVisit && isOwner && (
        <>
          <Button
            className="ma-home-hero__btn"
            onClick={() => {
              beaconReport('eventplace_hostview_ management_null_ preview_null_click');
              openSpace(hostId);
            }}
          >
            <ViewIcon />
            预览效果
          </Button>
          {isMobile() && (
            <Button
              className="ma-home-hero__btn ma-home-hero__btn--edit"
              onClick={() => {
                beaconReport('eventplace_hostview_ management_null_edit_main_click');
                router.push('/personal');
              }}
            >
              <PencileIcon />
              编辑资料
            </Button>
          )}
        </>
      )}
      <QRCodeShare
        url={qrCodeUrl}
        userName={hostDetail?.host_name as string}
        show={show}
        setShow={setShow}
      />
    </>
  );
};

const HomePageHeader: FC<{
  /** 是否是观众视角 */
  isVisit?: boolean;
  /** 是否此页面是否是自己的 */
  isOwner?: boolean;
  /** 主办方数据 */
  hostData?: HostDetailRes['data'];
  /** 当前页面状态 */
  pageType?: 0 | 1 | 2;
  /** 本地更新主页数据 */
  updateHostData?: (params: { path: string; value: any }[]) => void;
}> = ({ isVisit, isOwner, hostData, pageType, updateHostData }) => {
  const hostDetail = hostData?.host_detail;
  const { isMobileUi, userHostList } = useContext(AppContext);
  const { goUpdate, vipResource } = useCommercialize();
  const router = useRouter();
  const { host_id: hostId = hostDetail?.host_id } = router.query as {
    host_id: string;
    auto_follow?: string;
  };
  const [hostDrawer, setHostDrawer] = useState(false);
  // 获取当前头图宽度
  const { domWidth } = useImageWidthHooks(
    isMobileUi ? 'ma-home-hero__obj--section-mb' : 'ma-home-hero__obj--section',
  );
  // 版本类型
  const versionObj: any = useMemo(
    () => ({
      free: {
        type: undefined,
        bg: '',
        bgColor: '#F1F1F4',
      },
      basic: {
        type: 'base',
        bg: defaultBannerBase,
        bgColor: '#F4F7FC',
      },
      deluxe: {
        type: 'luxury',
        bg: defaultBannerLuxury,
        bgColor: '#FAF5EB',
      },
      ultimate: {
        type: 'ultimate',
        bg: defaultBannerUltimate,
        bgColor: '#E8E9F1',
      },
    }),
    [],
  );
  // 显示到期时间
  const expireDate = useMemo(() => {
    const { rule_type, end_time = 0 } = vipResource || {};
    const day = Math.floor((end_time - dayjs().valueOf()) / 86400000);
    if (rule_type === 'free' || !end_time || day > 30) return undefined;
    if (day < 1) return '已到期';
    return `${day}天后到期`;
  }, [vipResource]);

  const bgImage = useMemo(() => {
    if (!hostDetail?.host_id) return '';
    if (!hostDetail?.bg_mobile_url) return DefaultBannerM;
    return formatUrl({
      url: hostDetail?.bg_mobile_url,
      imgWidth: domWidth,
    });
  }, [hostDetail?.bg_mobile_url, hostDetail?.host_id, domWidth]);

  const bgWebImage = useMemo(() => {
    if (!hostDetail?.host_id) return '';
    if (!hostDetail?.bg_web_url) return versionObj[vipResource?.rule_type || 'free'].bg;
    return formatUrl({
      url: hostDetail?.bg_web_url,
      imgWidth: domWidth,
    });
  }, [hostDetail?.bg_web_url, hostDetail?.host_id, vipResource?.rule_type, domWidth]);

  const webColor = useMemo(() => {
    if (hostDetail?.host_id && !hostDetail?.bg_web_color)
      return versionObj[vipResource?.rule_type || 'free'].bgColor;
    return hostDetail?.bg_web_color || '#F1F1F4';
  }, [
    hostDetail?.bg_web_url,
    hostDetail?.host_id,
    hostDetail?.bg_web_color,
    vipResource?.rule_type,
  ]);

  const tag = useMemo(
    () => hostDetail?.label?.map((item) => ({ text: item, undeletable: true })),
    [hostDetail?.label],
  );
  const theme = useMemo(() => {
    if (isMobileUi || !hostDetail?.theme) return 'light';
    if (hostDetail.theme === 'dark') return 'light';
    return 'dark';
  }, [isMobileUi, hostDetail?.theme]);
  const scrollToActivity = useCallback(() => {
    if (isVisit) return;
    document.querySelector('.tea-tabs__tabpanel')?.scrollIntoView();
  }, []);

  const activitesNum = useMemo(() => {
    if (!hostDetail?.activity_info) return;
    return hostDetail?.activity_info?.total_count || 0;
  }, [hostDetail?.activity_info]);

  const gotoFans = useCallback(() => {
    if (isVisit) return;

    router.push('/fans');
  }, [router]);
  const goPerson = (type?: string) => {
    let link = '/personal';
    if (type) link += `?opt=${type}`;
    router.push(link);
  };

  // 移动端切换主办方账号
  const openSwitchAccount = () => {
    setHostDrawer(true);
  };
  const closeSwitch = () => {
    setHostDrawer(false);
  };
  // 头部切换
  const headerSlot = () => (
    <div className={`${style.drawerTitle} title`}>
      <span></span>
      <span>切换主办方</span>
      <CloseIcon onClick={closeSwitch} />
    </div>
  );

  if (isVisit)
    return (
      <HomeHero
        // style={{ marginBottom: '30px' }}
        avatar={hostDetail?.avatar_url}
        vip=""
        affiliation={hostDetail?.ip_attribution || '未知'}
        theme={theme}
        name={hostDetail?.host_name}
        activites={activitesNum}
        fans={hostDetail?.fans_info?.fans_count}
        tags={tag}
        industryTags={
          hostDetail?.industry_infos?.length
            ? hostDetail.industry_infos.map((item) => ({
                text: item.industry_name,
                undeletable: true,
              }))
            : undefined
        }
        onClickActivites={scrollToActivity}
        bg={bgWebImage}
        bgcolor={webColor}
        bgMb={bgImage}
        full={false}
        preview={pageType === 0 && '预览中'}
        responsive={true}
        btns={
          <Btns
            isVisit={isVisit}
            isOwner={isOwner}
            hostData={hostData}
            hostId={hostId}
            updateHostData={updateHostData}
          />
        }
      />
    );

  return (
    <>
      <HomeHero
        avatar={hostDetail?.avatar_url}
        radius
        vip=""
        affiliation={hostDetail?.ip_attribution || '未知'}
        theme={theme}
        name={hostDetail?.host_name}
        activites={activitesNum}
        fans={hostDetail?.fans_info?.fans_count}
        tags={tag}
        industryTags={
          hostDetail?.industry_infos?.length
            ? hostDetail.industry_infos.map((item) => ({
                text: item.industry_name,
                undeletable: true,
              }))
            : undefined
        }
        onClose={(item) => {
          if (item) {
            console.log(`删除了 ${item.text}`);
          }
        }}
        onClickActivites={scrollToActivity}
        onClickFans={gotoFans}
        // onClickEdit={goPerson}
        onAdd={tag && tag?.length < 5 ? () => goPerson('tag') : undefined}
        onIndustryAdd={goPerson}
        bg={bgWebImage}
        bgMb={bgImage}
        bgcolor={webColor}
        full={!isVisit}
        responsive={true}
        btns={
          <Btns
            isVisit={isVisit}
            isOwner={isOwner}
            hostData={hostData}
            hostId={hostId}
            updateHostData={updateHostData}
          />
        }
        onSwitchAccount={
          !hostDetail?.host_id || !userHostList || userHostList?.length <= 1
            ? undefined
            : openSwitchAccount
        }
        version={{
          type: versionObj[vipResource?.rule_type || 'free'].type,
          text: vipResource?.rule_name,
          expireDate,
          link:
            vipResource?.rule_type === 'free' ? { text: '版本升级', onClick: goUpdate } : undefined,
          onClickText: !isMobile() ? goUpdate : undefined,
        }}
      />
      <DrawerFormField
        visible={hostDrawer}
        onClose={closeSwitch}
        headerSlot={headerSlot()}
        className={style.drawerBox}
      >
        <SelectList onClose={closeSwitch} />
      </DrawerFormField>
    </>
  );
};
const SelectList = (props: { onClose?: Function }) => {
  const { onClose } = props;
  const { hostDetail, userHostList = [], setSelectHostId } = useContext(AppContext);
  return (
    <div className={`${style.hostList} ma-ticket-list responsive`}>
      {userHostList.map((item) => (
        <div
          className={`${style.hostListItem} ${
            hostDetail?.host_id === item?.host_id ? 'is-active' : ''
          } ma-ticket-list__item`}
          onClick={() => {
            setSelectHostId(item?.host_id, (id: any) => {
              console.log('selectId', id);
              onClose?.();
            });
          }}
        >
          <MemberOption imageUrl={item?.host_avatar_url} name={item?.host_name} />
        </div>
      ))}
    </div>
  );
};

export const useToggleFollowHost = (
  isSubscribe: boolean,
  hostId: string | number,
  isOwner: boolean,
  hostDetail: HostDetailData,
  onSuccess?: (isSubScribe: boolean) => void,
  notCallApp?: boolean,
) => {
  const router = useRouter();
  const toggleFollow = useCallback(
    (doSubscribe?: any, callback?: (isSubscribe: boolean) => void) => {
      // doSubscribe 用于响应唤起参数,如果已关注则忽略
      if (doSubscribe === true && isSubscribe) return;
      if (isOwner) return;
      // 唤起 app 进行关注
      if (!notCallApp) {
        if (
          !isWechat(navigator.userAgent) &&
          navigateToLaunchIfNeed(router, { auto_follow: 'true' })
        ) {
          return;
        }
      }
      if (!hostId || isOwner) return;
      const confirmPromise = isSubscribe
        ? confirm({
            title: '是否取消关注',
            content: '取消关注后您将无法获取主办方最新动态,是否取消',
            okTxt: '取消关注',
            cancelTxt: '再想想',
          })
        : Promise.resolve();
      checkLogin()
        .then((isLogin: boolean) => {
          if (!isLogin) {
            goLogin(0, { auto_follow: true });
            return Promise.reject();
          }
        })
        .then(() => {
          confirmPromise
            .then(() => {
              const c = message.loading({ content: '请稍候...', duration: 0 });
              subscribe(hostId, !isSubscribe)
                .then((success) => {
                  if (!success) {
                    message.error({ content: '操作失败,请稍后重试' });
                    return;
                  }
                  onSuccess?.(!isSubscribe);
                  callback?.(!isSubscribe);
                })
                .catch((e) => {
                  message.error({
                    content: `操作失败: ${typeof e === 'string' ? e : JSON.stringify(e)}`,
                  });
                })
                .finally(() => {
                  c.hide();
                });
            })
            .catch(() => {
              // pass
            });
        })
        .catch(() => {
          // pass
        });
    },
    [isSubscribe, hostId, isOwner, hostDetail?.fans_info],
  );
  return toggleFollow;
};

// 关注相关的hooks
export const useToggleFollow = (
  hostId: string | number,
  isOwner: boolean,
  onSuccess?: (isSubScribe: boolean) => void,
) => {
  const router = useRouter();
  const [isFollowed, setIsFollowed] = useState(false);

  const toggleFollow = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (isOwner) return;
      // 唤起 app 进行关注
      if (
        !isWechat(navigator.userAgent) &&
        navigateToLaunchIfNeed(router, { auto_follow: 'true' })
      ) {
        return;
      }
      if (!hostId || isOwner) return;
      const confirmPromise = isFollowed
        ? confirm({
            title: '是否取消关注',
            content: '取消关注后您将无法获取主办方最新动态,是否取消',
            okTxt: '取消关注',
            cancelTxt: '再想想',
          })
        : Promise.resolve();

      checkLogin()
        .then((isLogin: boolean) => {
          if (!isLogin) {
            goLogin(0, { auto_follow: true });
            return Promise.reject();
          }
        })
        .then(() => {
          confirmPromise
            .then(() => {
              const c = message.loading({ content: '请稍候...', duration: 0 });
              subscribe(hostId, !isFollowed)
                .then((res) => {
                  if (res.code !== 0) {
                    message.error({ content: '操作失败,请稍后重试' });
                    return;
                  }
                  setIsFollowed(!isFollowed);
                  onSuccess?.(!isFollowed);
                })
                .finally(() => {
                  c.hide();
                });
            })
            .catch(() => {
              // pass
            });
        })
        .catch(() => {
          // pass
        });
    },
    [isFollowed, hostId, isOwner],
  );

  return [isFollowed, toggleFollow];
};

export default HomePageHeader;
